import { Controller } from "@hotwired/stimulus"

// Client-side filtering of the public pilot catalogue. Replaces the former
// jQuery + isotope implementation with plain show/hide filtering (the grid
// items are full-width, so no masonry layout is required).
export default class extends Controller {
  static targets = ["keywords", "technology", "partner", "flowrateMin", "flowrateMax", "count", "item"]

  connect() {
    this.filter()
  }

  clear(event) {
    if (event) event.preventDefault()
    if (this.hasKeywordsTarget) this.keywordsTarget.value = ""
    if (this.hasTechnologyTarget) this.technologyTarget.value = ""
    if (this.hasPartnerTarget) this.partnerTarget.value = ""
    if (this.hasFlowrateMinTarget) this.flowrateMinTarget.value = ""
    if (this.hasFlowrateMaxTarget) this.flowrateMaxTarget.value = ""
    this.filter()
  }

  filter() {
    const keywords = this.value(this.keywordsTarget).toLowerCase()
    const technology = this.value(this.technologyTarget)
    const partner = this.value(this.partnerTarget)
    const flowrateMin = this.number(this.flowrateMinTarget)
    const flowrateMax = this.number(this.flowrateMaxTarget)

    let visible = 0

    this.itemTargets.forEach((item) => {
      let show = true

      if (keywords && !(item.dataset.keywords || "").toLowerCase().includes(keywords)) {
        show = false
      }

      if (show && technology && !item.classList.contains(`technology__${technology}`)) {
        show = false
      }

      if (show && partner && !item.classList.contains(`partner__${partner}`)) {
        show = false
      }

      if (show && (flowrateMin !== null || flowrateMax !== null)) {
        const flowrate = parseFloat(item.dataset.flowrate)
        if (!isNaN(flowrate)) {
          if (flowrateMin !== null && flowrate < flowrateMin) show = false
          if (flowrateMax !== null && flowrate > flowrateMax) show = false
        }
      }

      item.style.display = show ? "" : "none"
      if (show) visible += 1
    })

    if (this.hasCountTarget) this.countTarget.textContent = visible

    this.updateUrl(keywords, technology, partner, flowrateMin, flowrateMax)
  }

  updateUrl(keywords, technology, partner, flowrateMin, flowrateMax) {
    const params = new URLSearchParams()
    if (keywords) params.set("keywords", this.value(this.keywordsTarget))

    const filters = []
    if (technology) filters.push(`technology__${technology}`)
    if (partner) filters.push(`partner__${partner}`)
    if (filters.length) params.set("filters", filters.join(","))

    if (flowrateMin !== null) params.set("flowrate_min", flowrateMin)
    if (flowrateMax !== null) params.set("flowrate_max", flowrateMax)

    const query = params.toString()
    const url = query ? `${window.location.pathname}?${query}` : window.location.pathname
    window.history.replaceState(null, "", url)
  }

  value(target) {
    return target && target.value ? target.value : ""
  }

  number(target) {
    if (!target || target.value === "") return null
    const parsed = parseFloat(String(target.value).replace(/,/g, "."))
    return isNaN(parsed) ? null : parsed
  }
}
